import { render, staticRenderFns } from "./Pitches.vue?vue&type=template&id=b2849d5e&"
import script from "./Pitches.vue?vue&type=script&lang=js&"
export * from "./Pitches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports